import React from 'react';
import PageTitle from '../Shared/PageTitle/PageTitle';

const About = () => {
    return (
        <div>
            <PageTitle title="About"></PageTitle>
            <h2>This is our About </h2>
        </div>
    );
};

export default About;